const stringIsMarkdownForEmail = (string) => {    

  const asString = String(string)
  
    const mailLinkRegex = /^\[([\w\s\d]+)\]\(mailto:([\w@\.]+)\)/;
    const emailMatch = asString.match(mailLinkRegex);
    return emailMatch 
  };


export { stringIsMarkdownForEmail };